import React, { useMemo, useRef } from 'react';
import 'leaflet/dist/leaflet.css';
import { Circle, MapContainer, TileLayer, ZoomControl } from 'react-leaflet';
import { useMapLoadedStatus } from 'hooks/useMapLoadedStatus';
import { MAP_RADIUS, ZOOM_MAX_LEVEL, ZOOM_MIN_LEVEL } from 'constants/profile';
import * as leaflet from 'leaflet';
import { MapPropsInterface } from '../types';
import Markers from '../Markers';
import { CenterControl } from '../CenterControl';

const filterCoordinates = (coordinate: number) => parseFloat(coordinate.toFixed(5).slice(0, -3));

const Map = ({ markers, width, height }: MapPropsInterface) => {
  const mapRef = useRef(null);
  const { markersUpdated, positionsToCenterMap } = useMemo(() => {
    const markersWithLocation = markers.filter((pin) => Boolean(pin.coordinates[0] && pin.coordinates[1]));

    const updatedMarkers = markersWithLocation.map((marker) => ({
      ...marker,
      coordinates: [filterCoordinates(marker.coordinates[0]), filterCoordinates(marker.coordinates[1])],
    }));

    const positions = markersWithLocation.map(
      (pin) => [filterCoordinates(pin.coordinates[0]), filterCoordinates(pin.coordinates[1])] as [number, number]
    );

    return {
      markersUpdated: updatedMarkers,
      positionsToCenterMap: positions,
    };
  }, [markers]);
  const { dispatchStatus } = useMapLoadedStatus();

  const MAP_URL = process.env.NCA_MAP_URL;

  return (
    <MapContainer
      ref={mapRef}
      preferCanvas
      attributionControl={false}
      bounds={positionsToCenterMap}
      zoomControl={false}
      scrollWheelZoom={false}
      doubleClickZoom={false}
      className="map"
      whenReady={() => dispatchStatus(true)}
    >
      <TileLayer url={`${MAP_URL}styles/journeys/{z}/{x}/{y}.png`} maxZoom={ZOOM_MAX_LEVEL} minZoom={ZOOM_MIN_LEVEL} />
      <Markers markers={markersUpdated} width={width} height={height} />
      <ZoomControl position="bottomright" />
      <CenterControl markers={markersUpdated} />
      <Circle
        center={markersUpdated[0].coordinates as leaflet.LatLngExpression}
        radius={MAP_RADIUS}
        fillOpacity={0.54}
        color="rgba(186, 190, 201, 0.54)"
        interactive
        weight={0}
        data-testid="radius-circle"
      />
    </MapContainer>
  );
};

export default Map;
